module.exports = __webpack_public_path__ + "fonts/Lato-HeavyItalic.46f0461b.woff2";